import { jsx as _jsx } from "react/jsx-runtime";
function ThorswapIcon() {
    return (_jsx("svg", { className: "ui-size-full", viewBox: "0 0 20 22", fill: "currentColor", children: _jsx("path", { fillRule: "evenodd", d: "M0 22L15.3585 15.5315L10.5003 10.6044L19.1793 0L5.64071 5.67733L10.5003 10.6044L0 22ZM10.3964 8.363L14.2013 3.71405L8.266 6.20297L10.3964 8.363ZM10.5371 12.7781L5.78414 17.9363L12.7361 15.0084L10.5371 12.7781Z" }) }));
}
export default ThorswapIcon;
